// src/components/admin/UserTable.jsx
import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "components/ui/table";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "components/ui/select";
import { Button } from "components/ui/button";
import { Checkbox } from "components/ui/checkbox";
import { Trash2 } from "lucide-react";

function UserTable({ users, onRoleChange, onDeleteUser, onPermissionChange }) {
  const roles = ["admin", "editor", "viewer", "pending"];

  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Usuário</TableHead>
            <TableHead>Email</TableHead>
            <TableHead className="w-[180px]">Função Global</TableHead>
            <TableHead className="text-center">Acesso Excursões</TableHead>
            <TableHead className="text-center">Acesso Chalés</TableHead>
            <TableHead className="text-center">Acesso Dashboard</TableHead>
            <TableHead className="text-center">Acesso Estoque</TableHead>
            <TableHead className="text-right w-[100px]">Ações</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {users.map((user) => (
            <TableRow key={user.id}>
              <TableCell className="font-medium">
                {user.name || "Nome não disponível"}
              </TableCell>
              <TableCell>{user.email}</TableCell>
              <TableCell>
                <Select
                  value={user.role}
                  onValueChange={(newRole) => onRoleChange(user.id, newRole)}
                >
                  <SelectTrigger>
                    <SelectValue placeholder="Definir função..." />
                  </SelectTrigger>
                  <SelectContent>
                    {roles.map((role) => (
                      <SelectItem key={role} value={role}>
                        {role.charAt(0).toUpperCase() + role.slice(1)}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </TableCell>

              <TableCell className="text-center">
                <Checkbox
                  checked={user.permissions?.canViewExcursions ?? true}
                  onCheckedChange={(isChecked) =>
                    onPermissionChange(user.id, "canViewExcursions", isChecked)
                  }
                />
              </TableCell>

              <TableCell className="text-center">
                <Checkbox
                  checked={user.permissions?.canViewChales ?? true}
                  onCheckedChange={(isChecked) =>
                    onPermissionChange(user.id, "canViewChales", isChecked)
                  }
                />
              </TableCell>

              <TableCell className="text-center">
                <Checkbox
                  checked={!!user.permissions?.canViewDashboard}
                  onCheckedChange={(isChecked) =>
                    onPermissionChange(user.id, "canViewDashboard", isChecked)
                  }
                />
              </TableCell>

              <TableCell className="text-center">
                <Checkbox
                  checked={!!user.permissions?.canViewEstoque}
                  onCheckedChange={(isChecked) =>
                    onPermissionChange(user.id, "canViewEstoque", isChecked)
                  }
                />
              </TableCell>

              <TableCell className="text-right">
                <Button
                  variant="ghost"
                  size="icon"
                  className="text-destructive hover:text-destructive"
                  onClick={() => onDeleteUser(user.id, user.name)}
                >
                  <Trash2 className="h-4 w-4" />
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}

export default UserTable;
